import { __rest } from "tslib";
import * as React from 'react';
import { useRouter } from '../hooks/useRouter';
import { RouterProvider } from './routerProvider';
export function Router(props) {
    var children = props.children, fn = props.fn, routerOptions = __rest(props, ["children", "fn"]);
    var router = useRouter(fn, routerOptions);
    return React.createElement(RouterProvider, { value: router }, children);
}
